import classNames from 'classnames';
import classes from './Container.module.scss';

// size can be : 'small' | 'medium' | 'large' | 'regular' (default: 'regular')
// width will override size prop
function CustomContainer({ children, width, removeTopPadding, style, size }) {
    return (
        <div
            style={{ maxWidth: width, ...style }}
            className={classNames(
                classes.container,
                removeTopPadding && classes.noPadding,
                size && !width && classes[size]
            )}
        >
            {children}
        </div>
    );
}
export default CustomContainer;
